import React from 'react';
import classNames from 'classnames';
import { IconButton, Slide } from '@mui/material';
import { isDesktop } from 'react-device-detect';

import AppPlayer from '@/components/player';
import AppProfileButton from '../../profile/profile-btn';
import { usePlayer } from '@/infrastructure/context/player-context';
import { useNavbar } from '@/infrastructure/context/navbar-context';
import AppBreadcrumbs, { IBreadcrumb } from '@/components/common/breadcrumbs';
import {
  MenuRounded,
  MusicNoteOutlined,
  MusicNoteRounded,
} from '@mui/icons-material';
import s from './styles.module.scss';

interface IAppHeaderComponentProps {
  breadcrumbs?: IBreadcrumb[];
}

const AppHeader: React.FC<IAppHeaderComponentProps> = (props) => {
  const { breadcrumbs = [] } = props;
  const { togglePlayer, player } = usePlayer();
  const { toggleNavbar, opened } = useNavbar();

  const topClassNames = classNames(s['top'], {
    [s['opened']]: opened,
  });

  return (
    <header className={s['header']}>
      <div className={topClassNames}>
        <div className={s['player-wrapper']}>
          <div>
            <AppBreadcrumbs links={breadcrumbs} />
          </div>
          <div className={s['desktop-player']}>
            <Slide
              in={player.opened}
              direction="down"
              mountOnEnter
              unmountOnExit
            >
              <div className={s['player']}>{isDesktop && <AppPlayer />}</div>
            </Slide>
          </div>
        </div>
        <div className={s['controls']}>
          {player.currentTrack && (
            <IconButton
              onClick={togglePlayer}
              aria-label={player.opened ? 'hide player' : 'show player'}
              title={player.opened ? 'Hide player' : 'Show player'}
            >
              {player.opened ? <MusicNoteRounded /> : <MusicNoteOutlined />}
            </IconButton>
          )}
          <AppProfileButton />
          <IconButton
            aria-label="toggle navbar"
            className={s['menu-btn']}
            onClick={toggleNavbar}
            sx={{ display: { xs: 'inline-flex', md: 'none' } }}
          >
            <MenuRounded />
          </IconButton>
        </div>
      </div>
    </header>
  );
};

export default AppHeader;
